import { Text } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

import { getBackground, getTextColor } from './helpers'

export type HourStyleProps = {
  isSelected: boolean
  isDisabled: boolean
}

export const StyledButton = styled.button<HourStyleProps>`
  padding: 3px 5px;

  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  background: ${(props) => getBackground(props)};
  border-radius: ${theme.token.var('borderRadius.small')};
  cursor: pointer;
`

export const HourNumber = styled(Text)<HourStyleProps>`
  color: ${(props) => getTextColor(props)};
`
